import { MonitoringUnit } from '@ebalance/proto/bffuser/v1/setting_model_pb'
import { useTranslation } from 'react-i18next'

import { RadioButton } from '@enechain/ecloud-designsystem'

type Props = {
  value: MonitoringUnit
  onChange: (value: MonitoringUnit) => void
}

export const MonitoringUnitRadio = ({
  value,
  onChange,
}: Props): React.ReactElement => {
  const { t } = useTranslation()

  const handleChange = (v: string): void => {
    if (v === String(MonitoringUnit.MWH)) {
      onChange(MonitoringUnit.MWH)
    } else if (v === String(MonitoringUnit.KWH)) {
      onChange(MonitoringUnit.KWH)
    }
  }

  return (
    <RadioButton
      direction="row"
      aria-label={t('page:settings.personal.monitoringUnit.label')}
      onValueChange={(details) => handleChange(details.value ?? '')}
      radios={[
        {
          value: String(MonitoringUnit.MWH),
          label: t('page:settings.personal.monitoringUnit.mwh'),
        },
        {
          value: String(MonitoringUnit.KWH),
          label: t('page:settings.personal.monitoringUnit.kwh'),
        },
      ]}
      value={String(value)}
    />
  )
}
